import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConnectedRouter } from 'connected-react-router';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// OIDC Provider
import userAuthManager from 'utils/flowGate';
import { initializeHumanSecurity } from 'utils/humanSecurityUtil';
import { initializeRaygun } from './utils/raygunUtil';
import { OidcProvider, loadUser } from 'redux-oidc';
import { PersistGate } from 'redux-persist/integration/react';
import Router from 'router';
import Localization from 'components/Providers/Localization';
import DatadogLogsProvider from 'components/Providers/DatadogLogsProvider';
import { FeatureFlagProvider } from 'components/Providers/FeatureFlag';
import featureFlagConfig from 'config/featureFlags';
import { store, persistor, history } from './initStore';
import * as serviceWorker from './serviceWorker';

// app styles
import './global.scss';

initializeRaygun();
initializeHumanSecurity();

loadUser(store, userAuthManager);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <OidcProvider userManager={userAuthManager} store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Localization>
            <DatadogLogsProvider>
              <ConnectedRouter history={history}>
                <FeatureFlagProvider defaultFeatures={featureFlagConfig}>
                  <Router history={history} />
                </FeatureFlagProvider>
              </ConnectedRouter>
            </DatadogLogsProvider>
          </Localization>
        </PersistGate>
      </OidcProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root'),
);

// Unregister Service Workers during initial development
serviceWorker.unregister();
